import { Box, Text, VStack, Image, useColorModeValue } from "@chakra-ui/react";
import { Trans, useTranslation } from "react-i18next";

import { DEFAULT_WIDTH, PAGE_PADDING } from "../../helpers/constant";

export default function AboutUs() {
  const { t } = useTranslation();
  const textColor = useColorModeValue("gray.700", "gray.200"); // adapts to dark mode
  const captionColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Box w={DEFAULT_WIDTH} mx="auto" px={PAGE_PADDING}>
      <VStack spacing={8} align="start">
        <Text fontSize="lg" color={textColor} lineHeight="taller">
          <Trans
            i18nKey="aboutUs.paragraph1"
            components={{ strong: <strong /> }}
          />
        </Text>

        <Text fontSize="lg" color={textColor}>
          <Trans
            i18nKey="aboutUs.paragraph2"
            components={{ strong: <strong /> }}
          />
        </Text>
        <Image src="/images/about.png" />
        <Box>
          <Text fontSize="sm" color={captionColor}>
            {t("aboutUs.caption")}
          </Text>
        </Box>
      </VStack>
    </Box>
  );
}
